/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The question data type

Values: 0=String, 1=Boolean, 2=Number, 3=Date, 4=MultiChoice, 5=Files, 6=QuestionGroup
 * @export
 * @enum {number}
 */

export enum QuestionDataType {
    String = 0,
    Boolean = 1,
    Number = 2,
    Date = 3,
    MultiChoice = 4,
    Files = 5,
    QuestionGroup = 6
}


